// Admin test IDs
export const ATID = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  loginError: "admin-login-error",

  sidebar: "admin-sidebar",
  sidebarLink: (key) => `admin-sidebar-${key}`,
  sidebarLogout: "admin-sidebar-logout",

  dashboard: "admin-dashboard",
  statCard: (key) => `admin-stat-${key}`,
  quickCreateArticle: "admin-quick-create-article",
  quickCreateCategory: "admin-quick-create-category",

  articlesList: "admin-articles-list",
  articlesFilterQ: "admin-articles-filter-q",
  articlesFilterCategory: "admin-articles-filter-category",
  articlesFilterStatus: "admin-articles-filter-status",
  articlesFilterContentType: "admin-articles-filter-content-type",
  articlesFilterOrigin: "admin-articles-filter-origin",
  articlesFilterDateFrom: "admin-articles-filter-date-from",
  articlesFilterDateTo: "admin-articles-filter-date-to",
  articlesRow: (id) => `admin-articles-row-${id}`,
  articlesRowActions: (id) => `admin-articles-row-actions-${id}`,
  articleEditLink: (id) => `admin-article-edit-${id}`,
  articlePreviewLink: (id) => `admin-article-preview-${id}`,
  articleActionMenu: (id) => `admin-article-action-menu-${id}`,

  editor: "admin-article-editor",
  editorTitle: "admin-article-title",
  editorSlug: "admin-article-slug",
  editorSummary: "admin-article-summary",
  editorContent: "admin-article-content",
  editorCategory: "admin-article-category",
  editorAuthor: "admin-article-author",
  editorTags: "admin-article-tags",
  editorMainImage: "admin-article-main-image",
  editorImageCaption: "admin-article-image-caption",
  editorImageCredit: "admin-article-image-credit",
  editorPublishedAt: "admin-article-published-at",
  editorScheduledAt: "admin-article-scheduled-at",
  editorStatus: "admin-article-status",
  editorContentType: "admin-article-content-type",
  editorFeatured: "admin-article-featured",
  editorBreaking: "admin-article-breaking",
  editorSourceName: "admin-article-source-name",
  editorSourceUrl: "admin-article-source-url",
  editorSubmit: "admin-article-submit",
  editorSaveDraft: "admin-article-save-draft",

  categoriesPage: "admin-categories-page",
  categoriesTable: "admin-categories-table",
  categoryNew: "admin-category-new",
  categoryRow: (id) => `admin-category-row-${id}`,
  categoryEdit: (id) => `admin-category-edit-${id}`,
  categoryDelete: (id) => `admin-category-delete-${id}`,
  categoryToggle: (id) => `admin-category-toggle-${id}`,
  categoryDialog: "admin-category-dialog",
  categoryDialogName: "admin-category-dialog-name",
  categoryDialogSlug: "admin-category-dialog-slug",
  categoryDialogDescription: "admin-category-dialog-description",
  categoryDialogParent: "admin-category-dialog-parent",
  categoryDialogOrder: "admin-category-dialog-order",
  categoryDialogActive: "admin-category-dialog-active",
  categoryDialogMenu: "admin-category-dialog-menu",
  categoryDialogSubmit: "admin-category-dialog-submit",

  settingsPage: "admin-settings-page",
  settingsSiteName: "admin-settings-site-name",
  settingsTagline: "admin-settings-tagline",
  settingsEmail: "admin-settings-email",
  settingsPhone: "admin-settings-phone",
  settingsAddress: "admin-settings-address",
  settingsFooter: "admin-settings-footer",
  settingsFacebook: "admin-settings-facebook",
  settingsTwitter: "admin-settings-twitter",
  settingsInstagram: "admin-settings-instagram",
  settingsYoutube: "admin-settings-youtube",
  settingsSubmit: "admin-settings-submit",

  mediaPage: "admin-media-page",
  mediaUploadInput: "admin-media-upload-input",
  mediaUploadButton: "admin-media-upload-button",
  mediaFilterQ: "admin-media-filter-q",
  mediaFilterType: "admin-media-filter-type",
  mediaFilterDateFrom: "admin-media-filter-date-from",
  mediaFilterDateTo: "admin-media-filter-date-to",
  mediaCard: (id) => `admin-media-card-${id}`,
  mediaDetailPanel: "admin-media-detail",
  mediaDetailAlt: "admin-media-detail-alt",
  mediaDetailDescription: "admin-media-detail-description",
  mediaDetailCaption: "admin-media-detail-caption",
  mediaDetailCredit: "admin-media-detail-credit",
  mediaDetailAuthor: "admin-media-detail-author",
  mediaDetailFocal: "admin-media-detail-focal",
  mediaDetailSave: "admin-media-detail-save",
  mediaDetailDelete: "admin-media-detail-delete",
  mediaDetailUsage: "admin-media-detail-usage",
  mediaDetailCopyUrl: "admin-media-detail-copy-url",

  mediaPicker: "admin-media-picker",
  mediaPickerOpen: "admin-media-picker-open",
  mediaPickerConfirm: "admin-media-picker-confirm",
  mediaPickerCard: (id) => `admin-media-picker-card-${id}`,
  editorMainImageRemove: "admin-article-main-image-remove",

  homepagePage: "admin-homepage-page",
  homepageBlocksList: "admin-homepage-blocks-list",
  homepageBlockRow: (id) => `admin-homepage-block-row-${id}`,
  homepageBlockToggle: (id) => `admin-homepage-block-toggle-${id}`,
  homepageBlockDelete: (id) => `admin-homepage-block-delete-${id}`,
  homepageBlockDuplicate: (id) => `admin-homepage-block-duplicate-${id}`,
  homepageAddBlock: "admin-homepage-add-block",
  homepageSaveBlock: "admin-homepage-save-block",
  homepageEditorTitle: "admin-homepage-editor-title",
  homepageEditorKind: "admin-homepage-editor-kind",
  homepageEditorMode: "admin-homepage-editor-mode",
  homepageEditorCategory: "admin-homepage-editor-category",
  homepageEditorLimit: "admin-homepage-editor-limit",
  homepageEditorScheduleStart: "admin-homepage-editor-schedule-start",
  homepageEditorScheduleEnd: "admin-homepage-editor-schedule-end",
  homepageEditorReplacement: "admin-homepage-editor-replacement",
  homepageEditorEmbed: "admin-homepage-editor-embed",
  homepageEditorVisibilityDesktop: "admin-homepage-editor-visibility-desktop",
  homepageEditorVisibilityTablet: "admin-homepage-editor-visibility-tablet",
  homepageEditorVisibilityMobile: "admin-homepage-editor-visibility-mobile",
  homepageEditorPickArticle: "admin-homepage-editor-pick-article",
  homepageManualArticle: (id) => `admin-homepage-manual-article-${id}`,
  homepageManualArticleRemove: (id) => `admin-homepage-manual-remove-${id}`,
  homepagePreviewButton: "admin-homepage-preview-button",
  homepagePreviewDialog: "admin-homepage-preview-dialog",
  homepagePreviewDevice: (device) => `admin-homepage-preview-device-${device}`,

  // Users management
  usersPage: "admin-users-page",
  usersTable: "admin-users-table",
  usersFilterQ: "admin-users-filter-q",
  usersFilterRole: "admin-users-filter-role",
  usersFilterActive: "admin-users-filter-active",
  usersNew: "admin-users-new",
  userRow: (id) => `admin-user-row-${id}`,
  userEdit: (id) => `admin-user-edit-${id}`,
  userDelete: (id) => `admin-user-delete-${id}`,
  userReset: (id) => `admin-user-reset-${id}`,
  userToggleActive: (id) => `admin-user-toggle-active-${id}`,
  userCloseSessions: (id) => `admin-user-close-sessions-${id}`,

  userDialog: "admin-user-dialog",
  userDialogEmail: "admin-user-dialog-email",
  userDialogName: "admin-user-dialog-name",
  userDialogRole: "admin-user-dialog-role",
  userDialogActive: "admin-user-dialog-active",
  userDialogPassword: "admin-user-dialog-password",
  userDialogSubmit: "admin-user-dialog-submit",
  userDialogPermToggle: (code) => `admin-user-perm-${code}`,

  resetRequestsPanel: "admin-reset-requests",
  resetRequestRow: (id) => `admin-reset-request-${id}`,

  // Audit
  auditPage: "admin-audit-page",
  auditTable: "admin-audit-table",
  auditFilterQ: "admin-audit-filter-q",
  auditFilterAction: "admin-audit-filter-action",
  auditFilterResource: "admin-audit-filter-resource",
  auditFilterUser: "admin-audit-filter-user",
  auditFilterDateFrom: "admin-audit-filter-date-from",
  auditFilterDateTo: "admin-audit-filter-date-to",
  auditFilterResourceId: "admin-audit-filter-resource-id",
  auditApply: "admin-audit-apply",
  auditReset: "admin-audit-reset",
  auditRow: (id) => `admin-audit-row-${id}`,

  // Editorial stats
  statsPage: "admin-stats-page",
  statsPreset: (key) => `admin-stats-preset-${key}`,
  statsDateFrom: "admin-stats-date-from",
  statsDateTo: "admin-stats-date-to",
  statsAuthor: "admin-stats-author",
  statsCategory: "admin-stats-category",
  statsCity: "admin-stats-city",
  statsApply: "admin-stats-apply",
  statsReset: "admin-stats-reset",
  statsExportCsv: "admin-stats-export-csv",
  statsCard: (key) => `admin-stats-card-${key}`,
  statsChartDaily: "admin-stats-chart-daily",
  statsChartDevice: "admin-stats-chart-device",
  statsChartCategory: "admin-stats-chart-category",
  statsChartCity: "admin-stats-chart-city",
  statsTopArticles: "admin-stats-top-articles",
  statsByAuthor: "admin-stats-by-author",
  statsFeaturedList: "admin-stats-featured-list",
  statsBreakingList: "admin-stats-breaking-list",
  statsAdsSection: "admin-stats-ads-section",

  // AI editor buttons
  aiSummary: "admin-editor-ai-summary",
  aiTitles: "admin-editor-ai-titles",
  aiTitlesPick: (i) => `admin-editor-ai-title-pick-${i}`,
  aiTags: "admin-editor-ai-tags",
  aiSeo: "admin-editor-ai-seo",
  aiDialog: "admin-editor-ai-dialog",

  // Automation
  automationPage: "admin-automation-page",
  automationTab: (key) => `admin-automation-tab-${key}`,
  automationSourcesTable: "admin-automation-sources-table",
  automationSourceRow: (id) => `admin-automation-source-row-${id}`,
  automationSourceNew: "admin-automation-source-new",
  automationSourceEdit: (id) => `admin-automation-source-edit-${id}`,
  automationSourceDelete: (id) => `admin-automation-source-delete-${id}`,
  automationSourceForm: "admin-automation-source-form",
  automationSourceFieldName: "admin-automation-source-name",
  automationSourceFieldMainUrl: "admin-automation-source-main-url",
  automationSourceFieldFeedUrl: "admin-automation-source-feed-url",
  automationSourceFieldType: "admin-automation-source-type",
  automationSourceFieldStatus: "admin-automation-source-status",
  automationSourceFieldCity: "admin-automation-source-city",
  automationSourceFieldFrequency: "admin-automation-source-frequency",
  automationSourceFieldPriority: "admin-automation-source-priority",
  automationSourceFieldSelectorTitle: "admin-automation-source-selector-title",
  automationSourceFieldSelectorContent: "admin-automation-source-selector-content",
  automationSourceFieldSelectorImage: "admin-automation-source-selector-image",
  automationSourceFieldSelectorDate: "admin-automation-source-selector-date",
  automationSourceFieldNotes: "admin-automation-source-notes",
  automationSourceFieldAllowedHosts: "admin-automation-source-allowed-hosts",
  automationSourceFieldRenderJs: "admin-automation-source-render-js",
  automationSourceFieldRenderTimeout: "admin-automation-source-render-timeout",
  automationSourceFieldRenderExtraWait: "admin-automation-source-render-extra-wait",
  automationSourceMappingsSection: "admin-automation-source-mappings-section",
  automationSourceMappingAdd: "admin-automation-source-mapping-add",
  automationSourceMappingRow: (i) => `admin-automation-source-mapping-row-${i}`,
  automationSourceMappingKeyword: (i) => `admin-automation-source-mapping-keyword-${i}`,
  automationSourceMappingCategory: (i) => `admin-automation-source-mapping-category-${i}`,
  automationSourceMappingActive: (i) => `admin-automation-source-mapping-active-${i}`,
  automationSourceMappingPriority: (i) => `admin-automation-source-mapping-priority-${i}`,
  automationSourceMappingDelete: (i) => `admin-automation-source-mapping-delete-${i}`,
  automationSourceMappingTestInput: "admin-automation-source-mapping-test-input",
  automationSourceMappingTestBtn: "admin-automation-source-mapping-test-btn",
  automationSourceMappingTestResult: "admin-automation-source-mapping-test-result",
  automationSourceSave: "admin-automation-source-save",
  automationSourceCancel: "admin-automation-source-cancel",

  automationInboxRow: (id) => `admin-automation-inbox-row-${id}`,
  automationInboxFilterStatus: "admin-automation-inbox-filter-status",
  automationInboxFilterSource: "admin-automation-inbox-filter-source",
  automationInboxApprove: (id) => `admin-automation-inbox-approve-${id}`,
  automationInboxReject: (id) => `admin-automation-inbox-reject-${id}`,
  automationInboxProcess: (id) => `admin-automation-inbox-process-${id}`,
  automationInboxRetry: (id) => `admin-automation-inbox-retry-${id}`,
  automationInboxEdit: (id) => `admin-automation-inbox-edit-${id}`,
  automationInboxPublish: (id) => `admin-automation-inbox-publish-${id}`,
  automationInboxCheckbox: (id) => `admin-automation-inbox-check-${id}`,
  automationInboxSelectAll: "admin-automation-inbox-select-all",
  automationInboxBatchProcess: "admin-automation-inbox-batch-process",
  automationInboxRowProcessAi: (id) => `admin-automation-inbox-process-ai-${id}`,
  automationSourceTest: (id) => `admin-automation-source-test-${id}`,
  automationSourceRun: (id) => `admin-automation-source-run-${id}`,
  automationRunAll: "admin-automation-run-all",
  automationTestDialog: "admin-automation-test-dialog",

  // Login extra
  loginForgot: "admin-login-forgot",
  forgotDialog: "admin-forgot-dialog",
  forgotEmail: "admin-forgot-email",
  forgotSubmit: "admin-forgot-submit",

  // Change password
  changePwPage: "admin-change-pw-page",
  changePwCurrent: "admin-change-pw-current",
  changePwNew: "admin-change-pw-new",
  changePwConfirm: "admin-change-pw-confirm",
  changePwSubmit: "admin-change-pw-submit",

  // SEO editor section
  seoSection: "admin-seo-section",
  seoTitle: "admin-seo-title",
  seoDescription: "admin-seo-description",
  seoKeywords: "admin-seo-keywords",
  seoCanonical: "admin-seo-canonical",
  seoOgImagePick: "admin-seo-og-image-pick",
  seoOgImageRemove: "admin-seo-og-image-remove",
  seoPreviewGoogle: "admin-seo-preview-google",
  seoPreviewFb: "admin-seo-preview-fb",
  seoPreviewTwitter: "admin-seo-preview-twitter",

  // Site settings SEO tab
  settingsSeoDefaultTitle: "admin-settings-seo-default-title",
  settingsSeoDefaultDescription: "admin-settings-seo-default-description",
  settingsDefaultOgImage: "admin-settings-default-og-image",
  settingsTwitterHandle: "admin-settings-twitter-handle",
  settingsFacebookAppId: "admin-settings-facebook-app-id",
  settingsPublicSiteUrl: "admin-settings-public-site-url",
  settingsPublisherLogo: "admin-settings-publisher-logo",
  settingsRobotsTxt: "admin-settings-robots-txt",
  settingsGoogleVerification: "admin-settings-google-verification",
  settingsGoogleAnalytics: "admin-settings-google-analytics",
  settingsAboutTitle: "admin-settings-about-title",
  settingsAboutContent: "admin-settings-about-content",
  settingsPrivacyTitle: "admin-settings-privacy-title",
  settingsPrivacyContent: "admin-settings-privacy-content",
  settingsHeaderBrandBg: "admin-settings-header-brand-bg",
  settingsHeaderBrandBgHex: "admin-settings-header-brand-bg-hex",
};
